import api from "./api";
const base = "/knowledgebase";
export const KnowledgebaseAPI = {
  list: () => api(`${base}/articles`),
  get: (id) => api(`${base}/articles/${encodeURIComponent(id)}`),
  create: (article) => api(`${base}/articles`, { method: "POST", body: JSON.stringify(article) }),
  update: (id, article) => api(`${base}/articles/${encodeURIComponent(id)}`, { method: "PUT", body: JSON.stringify(article) }),
  revisions: (id) => api(`${base}/articles/${encodeURIComponent(id)}/revisions`),
};
